import { Card, CardBody, Col, Container, Form, FormGroup, Input, Label, Row, Table } from "reactstrap";
import { Btn, H4, } from "../../AbstractElements";
import { SearchTableButton } from "../../utils/Constant";
import { formatPhoneNumber, maskItem, URL_API } from "../../utils/helper/helpers"
import Breadcrumbs from "../../CommonElements/Breadcrumbs/Breadcrumbs";
import SweetAlert from 'sweetalert2';
import { useEffect, useRef, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { formatPrice, itemHasPermission, } from "../../utils/helper/helpers";
import '../../utils/helper/style.css';
import { Link } from "react-router-dom";
import useClientsListe, { cardClients, deleteClient } from "./apiClients";
import { PaiementClients } from "../../utils/helper/modal";

type Clients = { [key: string]: any }

const GestClients = () => {

    const [filterText, setFilterText] = useState("");
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [isSubmitting, setIsSubmitting] = useState<boolean>(false); // Gère l'état d'envoi
    const [filteredItems, setFilteredItems] = useState<Clients[]>([]);
    const [refresh, setRefresh] = useState(false);
    const client = useClientsListe(refresh) || [];
    const [show, setShow] = useState(false);
    const pdfRef = useRef<HTMLDivElement>(null);
    const Token = JSON.parse(localStorage.getItem("login")!);

    const [data, setData] = useState({
        nom: '',
        adresse: '',
        phone: '',
        id: null
    });
    const [erreur, setErreur] = useState({
        nom: '',
        adresse: '',
        phone: '',
        id: null
    });

    // Récupération initiale des filtres sauvegardés
    useEffect(() => {
        const savedFilterText = localStorage.getItem("filterText_clients") || "";

        setFilterText(savedFilterText);
    }, []);

    // Sauvegarde des filtres dans localStorage à chaque changement
    useEffect(() => {
        localStorage.setItem("filterText_clients", filterText);
    }, [filterText]);

    // Bouton pour réinitialiser les filtres
    const clearFilters = () => {
        localStorage.removeItem("filterText_clients");

        setFilterText("");
    };

    const changeHandler = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
        const { name, value } = e.target;
        setData((prevState) => ({
            ...prevState,
            [name]: value
        }));
    };

    const handleSubmitData = (e: React.FormEvent) => {
        e.preventDefault();
        setIsSubmitting(true); // Désactiver le bouton
        const url = data.id !== null ? `${URL_API}/client/update/${data.id}` : `${URL_API}/client/create`

        axios.post(url, { ...data }, {
            headers: {
                Authorization: `Bearer ${Token}`
            }
        }).then(response => {

            if (response.data.success) {
                toast.success("Enrégistrement éffectué avec succès");
                clearDataForm();
            }

        }).catch(error => {
            // console.log(error)
            toast.info("Oups !! Erreur de modification des données");
            if (error.response.status === 422) {

                setErreur(error.response.data.message);
            }
        })
        setRefresh((prev) => !prev);
        setIsSubmitting(false);
    }

    const Confirmation = ({ id, type }: { id: number, type: string }) => {
        SweetAlert.fire({
            title: 'Êtes-vous sûr?',
            text: "De Vouloir supprimer cet element ??",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Oui, supprimer !'
        }).then((result) => {
            if (result.isConfirmed) {
                deleteClient({ id: id }, () => setRefresh(!refresh));
            }
        });
    };

    const editerClients = ({ id }: { id: number }) => {
        const clients = filteredItems.find((item) => item.id === id);
        if (clients) {
            setData({
                nom: clients.name,
                adresse: clients.address,
                phone: clients.phone,
                id: clients.id
            });
            setShow(true);
        } else {
            toast.info('Cet element de figure pas dans nos données')
        }

    }

    const clearDataForm = () => {
        setData({
            nom: '',
            adresse: '',
            phone: '',
            id: null
        });
        setErreur({
            nom: '',
            adresse: '',
            phone: '',
            id: null
        });
        setShow(false);
    }

    // modal
    const [modal, setModal] = useState(false);
    const [clientId, setClientId] = useState<number>();
    const [montantRestant, setMontantRestant] = useState<number>();
    const staticModalToggle = () => setModal(!modal);

    const openModal = (id: number, montant: number) => {
        setClientId(id);
        setMontantRestant(montant);
        setModal(true);
    };

    useEffect(() => {
        const filtered = client.filter((item) =>
            (item.name && item.name.toLowerCase().includes(filterText.toLowerCase())) ||
            (item.phone && item.phone.toLowerCase().includes(filterText.toLowerCase())) ||
            (item.address && item.address.toLowerCase().includes(filterText.toLowerCase())) ||
            (item.type && item.type.toLowerCase().includes(filterText.toLowerCase())) 
        );
        setFilteredItems(filtered);
        setIsLoading(false)

    }, [client, filterText, refresh]);

    console.log(filteredItems);

    return (
        <div className='page-body'>
            {isLoading ? (
                <div className="loading-container">
                    <div className="spinner-container">
                        <div className="spinner"></div>
                        <span className="loading-text">Chargement de la plateforme...</span>
                    </div>
                </div>
                
                // <Loader/> // Afficher le loader tant que les données sont en cours de chargement
            ) : ( 
                <>
                    <Breadcrumbs mainTitle="Clients" parent="Listes" />
                    <Container fluid>
                        <Row>
                            <Col md="12">
                                {cardClients({ value: filteredItems })}
                            </Col>
                            <Col md="8">
                                <Card>
                                    <CardBody>
                                        <Row>
                                            <Col sm="5">
                                                <div className="relative w-full flex">
                                                    <Input
                                                    type="search"
                                                    value={filterText}
                                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setFilterText(e.target.value)}
                                                    placeholder="Rechercher..."
                                                    className="pr-10" // espace pour l’icône
                                                    />
                                                </div>
                                            </Col>
                                        </Row>
                                    </CardBody>
                                </Card>
                                <div ref={pdfRef}>

                                    <Card className="invoice-card">
                                        <CardBody className="invoice-table pt-0 checkbox-checked">
                                            
                                            <Table responsive id="all-invoice">
                                                <thead className="bg-info">
                                                    <tr>
                                                        <th className="text-white ">Clients</th>
                                                        <th className="text-white ">Montant Total</th>
                                                        <th className="text-white ">Reste À Payer</th>
                                                        {/* <th className="text-white ">Total Bons</th> */}
                                                        <th className="text-white ">Actions</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {filteredItems.map((item, index) => (

                                                        <tr key={index}>
                                                            <td>
                                                                <div className="d-flex align-items-center gap-2">
                                                                    <div className="flex-shrink-0">
                                                                        <i className="icofont icofont-user f-40 text-success"></i>
                                                                    </div>
                                                                    <div className="flex-grow-1">
                                                                        <span className="text-capitalize f-w-800 f-13"> {item.name}</span> <br />
                                                                        <span>{formatPhoneNumber(item.phone)}</span>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                            <td className="bg-light-success">
                                                                {maskItem(formatPrice(Number(item.total_ventes) + Number(item.montant_total)))}
                                                            </td>
                                                            <td className="bg-light-danger">
                                                                <span className="text-capitalize">
                                                                    {maskItem(formatPrice((Number(item.total_ventes) + Number(item.montant_total)) - Number(item.total_paiement)))}
                                                                </span>
                                                            </td>
                                                            {/* <td>
                                                                <span className="text-capitalize ">
                                                                    { parseInt(item.nombre_bons).toLocaleString('gn-GN') } Bons
                                                                </span>  <br />
                                                                <span className="text-capitalize"> dont {parseInt(item.total_tonne).toLocaleString('gn-GN')} tonnes</span>
                                                            </td> */}
                                                            <td>
                                                                {
                                                                    item.nombre_bons > 0 || Number(item.montant_total) > 0 ? (
                                                                        <>
                                                                            <Link to={`/clients/details/${item.id}`} className='btn bg-dark btn-xs mx-1 my-1 for-light'>
                                                                                <i className='fa fa-eye'></i>
                                                                            </Link>
                                                                            <Link to={`/clients/details/${item.id}`} className='btn bg-light-light btn-xs mx-1 my-1 for-dark'>
                                                                                <i className='fa fa-eye'></i>
                                                                            </Link>
                                                                            </>
                                                                    ) : (
                                                                        null
                                                                    )
                                                                }

                                                                {
                                                                    item.nombre_bons > 0 || Number(item.montant_total) > 0 && (itemHasPermission('super admin') || itemHasPermission('gest. clients ecriture') || itemHasPermission('admin')) && (
                                                                        <>
                                                                            <Btn className='bg-success btn-xs mx-1 my-1' onClick={() => openModal(item.id, item.total_ventes - item.total_paiement)}>
                                                                                Payer
                                                                            </Btn>
                                                                        </>
                                                                    )
                                                                }
                                                                
                                                                {
                                                                    (itemHasPermission('super admin') || itemHasPermission('gest. clients ecriture')) && (
                                                                        <>
                                                                            <Btn className='bg-info btn-xs mx-1 my-1' onClick={() => editerClients({ id: item.id })}>
                                                                                <i className='fa fa-pencil'></i>
                                                                            </Btn>
                                                                            <Btn className='bg-danger btn-xs mx-1 my-1' onClick={() => Confirmation({ id: item.id, type: 'supprimer' })}>
                                                                                <i className='fa fa-trash'></i>
                                                                            </Btn>
                                                                        </>
                                                                    )
                                                                }
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </Table>

                                        </CardBody>
                                    </Card>
                                </div>

                            </Col>
                            <Col md="4">
                                <Card>
                                    <CardBody>
                                        <Form onSubmit={handleSubmitData}>
                                            <H4 className="my-4 text-capitalize">
                                                Ajouter un Client
                                            </H4>

                                            <div className="product-info">
                                                <div className="product-group">
                                                    <Row>
                                                    <Col sm="12">
                                                            <FormGroup>
                                                                <Label>Nom Complet</Label>
                                                                <Input
                                                                    placeholder="Entrer le nom complet du client"
                                                                    name="nom"
                                                                    value={data.nom}
                                                                    onChange={changeHandler}
                                                                    type="text"
                                                                />
                                                                {erreur.nom && (
                                                                    <span className="text-danger">{erreur.nom}</span>
                                                                )}
                                                            </FormGroup>
                                                        </Col>
                                                        {/* <Col sm="12">
                                                            <FormGroup>
                                                                <Label>Type de clients</Label>
                                                                <Input
                                                                    name="type"
                                                                    value={data.type}
                                                                    onChange={changeHandler}
                                                                    type="select"
                                                                    className="form-control"
                                                                >
                                                                    <option value="">Selectionner...</option>
                                                                    <option value="Les Deux">Magazins et Bons</option>
                                                                    <option value="PDV Secondaire">Point de ventes Secondaire</option>
                                                                </Input>
                                                                {erreur.type && (
                                                                    <span className="text-danger">{erreur.type}</span>
                                                                )}
                                                            </FormGroup>
                                                        </Col> */}
                                                        
                                                        <Col sm="6">
                                                            <FormGroup>
                                                                <Label>Téléphone</Label>
                                                                <Input
                                                                    placeholder="Entrer le numéro de telephone"
                                                                    name="phone"
                                                                    value={data.phone}
                                                                    onChange={changeHandler}
                                                                    type="text"
                                                                />
                                                                {erreur.phone && (
                                                                    <span className="text-danger">{erreur.phone}</span>
                                                                )}
                                                            </FormGroup>
                                                        </Col>
                                                        <Col sm="6">
                                                            <FormGroup>
                                                                <Label>Adresse</Label>
                                                                <Input
                                                                    placeholder="Entrer l'adresse"
                                                                    name="adresse"
                                                                    value={data.adresse}
                                                                    onChange={changeHandler}
                                                                    type="text"
                                                                />
                                                                {erreur.adresse && (
                                                                    <span className="text-danger">{erreur.adresse}</span>
                                                                )}
                                                            </FormGroup>
                                                        </Col>
                                                    </Row>
                                                </div>
                                            </div>
                                            {
                                                (itemHasPermission('admin') || itemHasPermission('super admin') || itemHasPermission('gest. clients ecriture')) && (
                                                    <div className="text-end">
                                                        <Btn color="info" type="submit" disabled={isSubmitting}>
                                                        {data.id == null ? (isSubmitting ? "En cours d'ajout..." : "Ajouter") : (isSubmitting ? "Sauvegarde en cours..." : "Sauvegarder")}
                                                        </Btn>
                                                        <Btn className="btn btn-danger ms-3" onClick={() => clearDataForm()}>
                                                            Annuler
                                                        </Btn>
                                                    </div>
                                                )
                                            }
                                        </Form>
                                    </CardBody>

                                </Card>

                            </Col>
                        </Row>
                        
                    </Container>
                </>
            )}
            {
                PaiementClients({
                    isOpen: modal,
                    montant: montantRestant ?? 0,
                    client_id: clientId ?? 0,
                    toggle: staticModalToggle,
                }, () => setRefresh(!refresh))
            }
        </div >

    )
}

export default GestClients
